import type { ReactElement } from "react"

import { Trans } from "react-i18next"

import { Link } from "@mui/material"
import { Typography } from "@synapse-analytics/synapse-ui"

import type { EntryDisclaimerProps } from "../interfaces"

import styles from "./EntryDisclaimer.module.scss"

/**
 * entry disclaimer text to show policy and terms and conditions
 *
 * @param  {string} type to condition the wording of the text
 * @return  {<EntryDisclaimer />}
 */
export function EntryDisclaimer(props: Readonly<EntryDisclaimerProps>): ReactElement {
  const { type } = props

  return (
    <Typography variant="p" color="base" align="center" className={styles.disclaimerContainer}>
      <Trans
        i18nKey={`entryDisclaimer.${type}`}
        ns="auth"
        components={[
          <Link
            key="terms"
            href="https://www.synapse-analytics.io/konan-terms-and-conditions"
            target="_blank"
            underline="hover"
            aria-label="terms-and-conditions"
          />,
          <Link
            key="privacy"
            href="https://www.synapse-analytics.io/konan-privacy-policy"
            target="_blank"
            underline="hover"
            aria-label="privacy-policy"
          />,
        ]}
      />
    </Typography>
  )
}
